import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import QuoteForm from '../components/forms/QuoteForm/QuoteForm';
import './QuotePage.css';

export default function QuotePage() {
  const { t } = useTranslation();
  return (
    <main>
      <Helmet>
        <title>{t('seo.quote_title')}</title>
        <meta name="description" content={t('seo.quote_desc')} />
      </Helmet>
      <h1>{t('nav.quote')}</h1>
      <QuoteForm />
    </main>
  );
}
